const DEFAULT_STATE = -1;
const CLOSED_STATE = 0;
const FIRST_OPEN_STATE = 1;
const SECOND_OPEN_STATE = 2;

function getNextState(curState, reviewAmount) {
    if (curState === DEFAULT_STATE) {
        return CLOSED_STATE;
    } else if (curState === CLOSED_STATE) {
        return reviewAmount <= ((15*2) + 2) ? FIRST_OPEN_STATE : SECOND_OPEN_STATE;
    } else if (curState === FIRST_OPEN_STATE) {
        return reviewAmount <= ((65*2) + 2) ? SECOND_OPEN_STATE : CLOSED_STATE;
    } else {
        return CLOSED_STATE;
    }
}

function getButtonTranslationKey(state) {
    switch (state) {
        case DEFAULT_STATE:
            return 'reviews-show-more';
        case CLOSED_STATE:
            return 'reviews-show-more';
        case FIRST_OPEN_STATE:
            return 'reviews-show-all';
        case SECOND_OPEN_STATE:
            return 'reviews-show-less';
    }
}

function getButtonStateClass(state, containerClassName) {
    switch (state) {
        case DEFAULT_STATE:
            return containerClassName + '--default-view';
        case CLOSED_STATE:
            return containerClassName + '--limited-view';
        case FIRST_OPEN_STATE:
            return containerClassName + '--extended-view';
        case SECOND_OPEN_STATE:
            return containerClassName + '--full-view';
    }
}

export {
    DEFAULT_STATE,
    CLOSED_STATE,
    FIRST_OPEN_STATE,
    SECOND_OPEN_STATE,
    getNextState,
    getButtonTranslationKey,
    getButtonStateClass
};